import { mergeQueryKeys } from '@lukemorales/query-key-factory';
import type {
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
} from '@tanstack/react-query';

import { apiKeys } from './apiKey';
import { applicationWebhooks } from './applicationWebhooks';
import { blog } from './blog';
import { bulletPoints } from './bulletPoints';
import { candidateProfile } from './candidateProfile';
import { cezCvGenerator } from './cezCvGenerator';
import { changelog } from './changelog';
import { common } from './common';
import { community } from './community';
import { cvGenerator } from './cvGenerator';
import { externalCandidates } from './externalCandidates';
import { externalOffers } from './externalOffers';
import { geoSuggestion } from './geoSuggestion';
import { industries } from './industries';
import { jobMatching } from './jobMatching';
import { offerAdmin } from './offerAdmin';
import { offerRecommendations } from './offerRecommendations';
import { payments } from './payments';
import { profile } from './profile';
import { reasoningSearch } from './reasoningSearch';
import { resumeBuilder } from './resumeBuilder';
import { resumeChecker } from './resumeChecker';
import { resumeToOfferAnalysis } from './resumeToOfferAnalysis';
import { settings } from './settings';
import { teamMembers } from './teamMembers';
import { tests } from './tests';

export const queries = mergeQueryKeys(
  cvGenerator,
  common,
  profile,
  payments,
  settings,
  jobMatching,
  externalCandidates,
  changelog,
  externalOffers,
  community,
  bulletPoints,
  candidateProfile,
  geoSuggestion,
  offerAdmin,
  apiKeys,
  applicationWebhooks,
  resumeChecker,
  reasoningSearch,
  resumeBuilder,
  tests,
  blog,
  cezCvGenerator,
  resumeToOfferAnalysis,
  teamMembers,
  offerRecommendations,
  industries
);

export type UseQueryFactoryProps<
  T extends { queryFn: (...args: any) => any; queryKey: QueryKey }
> = UseQueryOptions<
  Awaited<ReturnType<T['queryFn']>>,
  unknown,
  Awaited<ReturnType<T['queryFn']>>,
  T['queryKey']
>;

export type UseMutationFactoryProps<
  T extends { queryFn: (...args: any) => any; queryKey: QueryKey }
> = UseMutationOptions<
  Awaited<ReturnType<T['queryFn']>>,
  unknown,
  Awaited<ReturnType<T['queryFn']>>,
  T['queryKey']
>;
